/**
 * Company Contact Configuration - Single Source of Truth (SSOT)
 *
 * All company contact details are centralized here.
 * Update this file to change contact information across the entire application.
 */

export const COMPANY = {
  // Brand
  name: "TrustedHeal",
  tagline: "Your trusted partner for world-class medical care in India",
  website: "https://trustedheal.com",

  // Phone Numbers
  phone: {
    raw: "+919876265548", // For tel: links
    display: "+91 98762 65548", // For display (masked for privacy)
    displayFull: "+91 98762 65548", // Full display format
  },

  // WhatsApp
  whatsapp: {
    number: "919876265548", // Without + for wa.me links
    defaultMessage: "Hi, I'm interested in learning more about medical treatment options in India.",
    get link() {
      return `https://wa.me/${this.number}`;
    },
  },

  // Email Addresses
  email: {
    info: "info@trustedheal.com",
    care: "care@trustedheal.com",
    support: "support@trustedheal.com",
  },

  // Office Location
  address: {
    short: "Cyber City, Gurugram, Delhi NCR, India",
    full: "Cyber City, DLF Phase 2, Gurugram, Haryana 122002, India",
    multiline: "Cyber City, Gurugram\nDelhi NCR, India",
    city: "Gurugram",
    state: "Haryana",
    country: "India",
    pincode: "122002",
  },

  // Google Maps
  maps: {
    query: "Cyber+City,+DLF+Phase+2,+Gurugram,+Haryana+122002,+India",
    get link() {
      return `https://maps.google.com/?q=${this.query}`;
    },
  },

  // Social Media Links
  social: {
    facebook: "#",
    instagram: "#",
    linkedin: "#",
    youtube: "#",
    twitter: "#",
  },

  // Business Hours
  hours: {
    weekdays: "9:00 AM - 6:00 PM IST",
    weekends: "10:00 AM - 4:00 PM IST",
    timezone: "IST (Indian Standard Time)",
  },
} as const;

// Helper functions for generating links
export const getPhoneLink = () => `tel:${COMPANY.phone.raw}`;
export const getEmailLink = (type: keyof typeof COMPANY.email = "info") => `mailto:${COMPANY.email[type]}`;
export const getWhatsAppLink = (message?: string) => {
  const baseUrl = COMPANY.whatsapp.link;
  const text = message ?? COMPANY.whatsapp.defaultMessage;
  return `${baseUrl}?text=${encodeURIComponent(text)}`;
};
export const getMapsLink = () => COMPANY.maps.link;
